import StyledTextInput from "features/shared/components/text-input/styles/StyledTextInput.styled";
import styled from "styled-components";

const StyledLoginForm = styled.div`
  display: grid;
  grid-auto-rows: auto;
  gap: 24px;

  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 24px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusPageCard};

  ${StyledTextInput} {
    min-width: 250px;
  }
`;

export default StyledLoginForm;
